import { memoize } from 'underscore';

export const getNavigateSectionStyles = memoize(({ isBorderInsteadOfShadow = false } = {}) => (_, { palette = {} }) => ({
  backToCampaign: {
    height: 44,
    backgroundColor: palette.neutralLighter,
    ...isBorderInsteadOfShadow ? {
      borderBottom: `solid 1px ${palette.neutralQuaternaryAlt}`,
    } : {
      boxShadow: '0px 0.6px 1.8px rgba(0, 0, 0, 0.108), 0px 3.2px 7.2px rgba(0, 0, 0, 0.132)',
    },
  },
  backToCampaignLink: {
    lineHeight: '19px',
    fontSize: 14,
    color: palette.themeDarkAlt,
    margin: 1,
    padding: [12, 0, 12, 0],
    '&:focus': {
      outline: '1px solid #605E5C',
    },
    '& .icon-Back': {
      fontSize: 16,
      width: 16,
      height: 16,
      marginRight: 8,
    },
  },
}), (...args) => JSON.stringify(args));
